import AddonForm from "@coworker/app/src/components/AddonForm";
import CustomerMFAQ from "@coworker/app/src/components/MFAQ/CustomerMFAQ";
import NewQuestionMFAQ from "@coworker/app/src/components/MFAQ/NewQuestion";
import CustomerMFAQDetail from "@coworker/app/src/components/MFAQ/QuestionDetailsPage/CustomerMFAQDetail";
import { NearbyAddons } from "@coworker/app/src/components/NearbyAddons/NearbyAddons";
import { RelatedTasks } from "@coworker/app/src/components/RelatedTasks";
import { CreateMediaView } from "@coworker/app/src/components/RoomSettings/Medias/CreateMediaView";
import { GroupView } from "@coworker/app/src/components/RoomSettings/Medias/GroupView";
import { MediasView } from "@coworker/app/src/components/RoomSettings/Medias/MediasView";
import { TabbedMediaView } from "@coworker/app/src/components/RoomSettings/Medias/TabbedMediaView";
import { UpdateMediaView } from "@coworker/app/src/components/RoomSettings/Medias/UpdateMediaView";
import { CreateTaskView } from "@coworker/app/src/components/RoomSettings/Tasks/CreateTaskView";
import { OngoingTasksListingView } from "@coworker/app/src/components/RoomSettings/Tasks/OngoingTasksListingView";
import { Cashline } from "@coworker/app/src/components/ShoppingTools/Cashline/Cashline";
import { MarkethallOW } from "@coworker/app/src/components/ShoppingTools/Markethall/MarkethallOW";
import { ShoppingToolsOverview } from "@coworker/app/src/components/ShoppingTools/Overview/ShoppingToolsOverview";
import { ProgressOverview } from "@coworker/app/src/components/ShoppingTools/Progress/ProgressOverview";
import { ShoppingToolsSettings } from "@coworker/app/src/components/ShoppingTools/Settings/ShoppingToolsSettings";
import { ShowroomOW } from "@coworker/app/src/components/ShoppingTools/Showroom/ShowroomOW";
import StoreContacts from "@coworker/app/src/components/StoreContacts";
import { generateTaskForm } from "@coworker/app/src/components/TaskForm";
import { TeamMembers } from "@coworker/app/src/components/TeamMembers";
import { ArticleDetailsPage } from "@coworker/app/src/components/TestBuy/ArticleDetailPage/ArticleDetailsPage";
import { CustomTestBuyForm } from "@coworker/app/src/components/TestBuy/NewTestBuy/CustomTestBuyForm";
import { NewTestBuyForm } from "@coworker/app/src/components/TestBuy/NewTestBuy/NewTestBuyForm";
import { TestBuyOverview } from "@coworker/app/src/components/TestBuy/Overview/TestBuyOverview";
import { TestbuyTaskCreationPage } from "@coworker/app/src/components/TestBuy/TaskCreationPage/TestbuyTaskCreationPage";
import { TestbuyDirectLink } from "@coworker/app/src/components/TestBuy/TestBuyDetailPage/TestbuyDirectLink";
import { PIPHomeView } from "@coworker/app/src/features/PIP/PIPHomeView";
import { PIPStockView } from "@coworker/app/src/features/PIP/PIPStockView";
import AtkomstUsersPage from "@coworker/apprestructured/src/atkomst-users/components/AtkomstUsersPage";
import FeatureFlagOverviewPage from "@coworker/apprestructured/src/feature-flag-management/components/FeatureFlagOverviewPage";
import { HomePage } from "@coworker/apprestructured/src/home/components/HomePage/HomePage";
import Insights from "@coworker/apprestructured/src/insights/components/Insights";
import LaunchMediaPage from "@coworker/apprestructured/src/launch-media/pages/LaunchMediaPage";
import { MediaDetailPage } from "@coworker/apprestructured/src/launch-media/pages/MediaDetailPage/MediaDetailPage";
import { ServiceOfficeMediaDetailPage } from "@coworker/apprestructured/src/launch-media/pages/ServiceOfficeMediaDetailPage/ServiceOfficeMediaDetailPage";
import { MainLayout } from "@coworker/apprestructured/src/layout/components/MainLayout/MainLayout";
import { MsalWrapper } from "@coworker/apprestructured/src/layout/components/MsalWrapper/MsalWrapper";
import TaskManagementDevOnly from "@coworker/apprestructured/src/layout/components/TaskManagementDevOnly/TaskManagementDevOnly";
import { HomeRedirector } from "@coworker/apprestructured/src/login/components/HomeRedirector/HomeRedirector";
import { NewUserPage } from "@coworker/apprestructured/src/login/components/NewUserPage/NewUserPage";
import { NewUserTeamPage } from "@coworker/apprestructured/src/login/components/NewUserTeamPage/NewUserTeamPage";
import { TeamSelection } from "@coworker/apprestructured/src/login/components/TeamSelection/TeamSelection";
import {
  MediaArticleInformationLandingPage,
  MediaArticleInformationLandingPageSearch,
  MediaSimpleArticleInformationLandingPage,
} from "@coworker/apprestructured/src/media-maintenance/pages/MediaArticleInformationLandingPage";
import ItemsSelectionView from "@coworker/apprestructured/src/multi-order-addons/components/ItemsSelection/ItemsSelectionView";
import RefillAreasView from "@coworker/apprestructured/src/multi-order-addons/components/RefillAreas/RefillAreasView";
import DefaultScannerPage from "@coworker/apprestructured/src/scan-and-search/pages/default-scanner-page/DefaultScannerPage";
import ScannerDebugPage from "@coworker/apprestructured/src/scan-and-search/pages/scanner-debug-page/ScannerDebugPage";
import ComponentDemoLandingPage from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoLandingPage/ComponentDemoLandingPage";
import CardsPage from "@coworker/apprestructured/src/task-management/demo/pages/GenericCategories/CardsPage";
import FilesAndArticlesPage from "@coworker/apprestructured/src/task-management/demo/pages/GenericCategories/FilesAndArticlesPage";
import InputsPage from "@coworker/apprestructured/src/task-management/demo/pages/GenericCategories/InputsPage";
import ModalsPage from "@coworker/apprestructured/src/task-management/demo/pages/GenericCategories/ModalsPage";
import OtherPage from "@coworker/apprestructured/src/task-management/demo/pages/GenericCategories/OtherPage";
import ViewerComponentsPage from "@coworker/apprestructured/src/task-management/demo/pages/GenericCategories/ViewerComponentsPage";
import TaskCardPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskCardPage/TaskCardPage";
import TaskTypesCreatePage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesCreatePage/TaskTypesCreatePage";
import TaskTypesEditPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesEditPage/TaskTypesEditPage";
import TaskTypesListPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesListPage/TaskTypesListPage";
import TaskTypesPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesPage";
import TaskTypesViewPage from "@coworker/apprestructured/src/task-management/demo/pages/TaskTypesViewPage/TaskTypesViewPage";
import { TasksOverview } from "@coworker/apprestructured/src/TasksOverview/components/TasksOverview";
import TeamManager from "@coworker/apprestructured/src/teams-management/components/TeamManager";
import TeamsAndUsersOverview from "@coworker/apprestructured/src/teams-management/components/TeamsAndUsersOverview";
import { createBrowserRouter, Navigate } from "react-router";

// Routes rendered inside MainLayout (shared chrome: nav/header/footer).
const mainLayoutChildren = [
  {
    path: "/",
    Component: HomeRedirector,
  },
  {
    path: "/login",
    Component: HomeRedirector,
  },
  {
    path: "/home",
    Component: HomePage,
  },
  {
    path: "/team",
    Component: TeamMembers,
  },
  {
    path: "/contacts",
    Component: StoreContacts,
  },
  {
    path: "/insights",
    Component: Insights,
  },

  // Multi order addons
  {
    path: "/multi-order-addons",
    Component: RefillAreasView,
  },
  { path: "/tasks", Component: TasksOverview },
  {
    path: "/customerquestions",
    Component: CustomerMFAQ,
  },
  // TestBuy
  {
    path: "/testbuy",
    Component: TestBuyOverview,
  },
  // Shopping tools
  {
    path: "/shoppingtools",
    Component: ShoppingToolsOverview,
  },
  // Medias
  {
    path: "/mediamaintenance",
    Component: MediasView,
  },
  {
    path: "/launch-media",
    Component: LaunchMediaPage,
  },
  {
    path: "/launch-media/:id",
    Component: MediaDetailPage,
  },
  {
    path: "/launch-media/service-office/:id",
    Component: ServiceOfficeMediaDetailPage,
  },
  {
    path: "/scanner/:type",
    Component: DefaultScannerPage,
  },
  {
    path: "/scanner-debug",
    Component: ScannerDebugPage,
  },
  {
    path: "/tasks/new",
    element: (
      <TaskManagementDevOnly>
        <TaskTypesPage />
      </TaskManagementDevOnly>
    ),
  },
  // Teams manager
  {
    path: "/teams",
    Component: TeamsAndUsersOverview,
  },
  {
    path: "/teams/store/:storeId",
    Component: TeamsAndUsersOverview,
  },
  {
    path: "/teams/store/:storeId/team/:teamId",
    Component: TeamManager,
  },
  {
    path: "/feature-flags",
    Component: FeatureFlagOverviewPage,
  },
  {
    path: "/atkomst-users",
    Component: AtkomstUsersPage,
  },
  {
    path: "/task-card/:id",
    element: (
      <TaskManagementDevOnly>
        <TaskCardPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-types/create",
    element: (
      <TaskManagementDevOnly>
        <TaskTypesCreatePage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-types/:id",
    element: (
      <TaskManagementDevOnly>
        <TaskTypesViewPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-types/:id/edit",
    element: (
      <TaskManagementDevOnly>
        <TaskTypesEditPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-types",
    element: (
      <TaskManagementDevOnly>
        <TaskTypesListPage />
      </TaskManagementDevOnly>
    ),
  },
];

// Fullscreen routes rendered as siblings of MainLayout (no header/footer chrome).
const fullscreenRoutes = [
  {
    path: "/teamselection",
    Component: TeamSelection,
  },
  {
    path: "/newuser",
    Component: NewUserPage,
  },
  {
    path: "/newuserteamselection",
    Component: NewUserTeamPage,
  },
  {
    path: "/task/new/addon",
    Component: AddonForm,
  },
  // Tasks - create/edit
  {
    path: "/task/new/product",
    Component: generateTaskForm("product", "create"),
  },
  {
    // PQR creation is v2-only; the legacy create route has been removed.
    // The edit route is kept so existing v1 PQR tasks remain editable until
    // v1 is fully decommissioned.
    path: "/task/edit/product_quality/:id",
    Component: generateTaskForm("product_quality", "edit"),
  },
  {
    path: "/task/edit/product/:id",
    Component: generateTaskForm("product", "edit"),
  },
  {
    path: "/task/new/addon/nearby",
    Component: NearbyAddons,
  },
  {
    path: "/task/edit/addon/:id",
    Component: generateTaskForm("addon_edit", "edit"),
  },
  {
    path: "/task/new/custom",
    Component: generateTaskForm("custom", "create"),
  },
  {
    path: "/task/new/mfaq_followup",
    Component: generateTaskForm("mfaq_followup", "create"),
  },
  {
    path: "/task/edit/mfaq_followup/:id",
    Component: generateTaskForm("mfaq_followup", "edit"),
  },
  {
    path: "/task/edit/custom/:id",
    Component: generateTaskForm("custom", "edit"),
  },
  {
    path: "/task/edit/planned/:id",
    Component: generateTaskForm("planned", "edit"),
  },
  {
    path: "/task/:id/changes",
    Component: generateTaskForm("addon_changes", "complete"),
  },
  { path: "/tasks/related/:id", Component: RelatedTasks },
  {
    path: "/multi-order-addons/refill-area/:refillAreaId",
    Component: ItemsSelectionView,
  },
  {
    path: "/shoppingtools/settings",
    Component: ShoppingToolsSettings,
  },
  {
    path: "/mediamaintenance/tabs/:mediaId",
    Component: TabbedMediaView,
  },
  {
    path: "/mediamaintenance/groups/:groupId",
    Component: GroupView,
  },
  {
    path: "/mediamaintenance/articles/:articleId",
    Component: MediaSimpleArticleInformationLandingPage,
  },
  {
    path: "/mediamaintenance/medias/:mediaId/articles/:articleId/product_article_id/:productArticleId",
    Component: MediaArticleInformationLandingPage,
  },
  {
    path: "/mediamaintenance/:mediaId/articles/:articleId/createtask",
    Component: CreateTaskView,
  },
  {
    path: "/mediamaintenance/articles/search/:productArticleId",
    Component: MediaArticleInformationLandingPageSearch,
  },
  {
    path: "/mediamaintenance/update/:mediaId",
    Component: UpdateMediaView,
  },
  {
    path: "/task/edit/room-settings/:id",
    Component: generateTaskForm("roomsettings_edit", "edit"),
  },
  {
    path: "/shoppingtools/progress",
    Component: ProgressOverview,
  },
  {
    path: "/shoppingtools/progress/showroom/:id",
    Component: ShowroomOW,
  },
  {
    path: "/shoppingtools/progress/markethall/:id",
    Component: MarkethallOW,
  },
  {
    path: "/shoppingtools/progress/cashline/:id",
    Component: Cashline,
  },
  {
    path: "/customerquestions/new",
    Component: NewQuestionMFAQ,
  },
  {
    path: "/customerquestions/:id",
    Component: CustomerMFAQDetail,
  },
  { path: "/product/:full_id", Component: PIPHomeView },
  { path: "/product/:full_id/stock", Component: PIPStockView },

  {
    path: "/testbuy/:id",
    Component: TestbuyDirectLink,
  },
  {
    path: "/testbuy/:id/article/:articleId",
    Component: ArticleDetailsPage,
  },
  {
    path: "/testbuy/new",
    Component: NewTestBuyForm,
  },
  {
    path: "/testbuy/custom/:location",
    Component: CustomTestBuyForm,
  },
  {
    path: "/testbuy/:id/article/:articleId/createTask",
    Component: TestbuyTaskCreationPage,
  },
  {
    path: "/mediamaintenance/create",
    Component: CreateMediaView,
  },
  {
    path: "/mediamaintenance/tasks",
    Component: OngoingTasksListingView,
  },
  {
    path: "/task-management-components",
    element: (
      <TaskManagementDevOnly>
        <ComponentDemoLandingPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-management-components/inputs",
    element: (
      <TaskManagementDevOnly>
        <InputsPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-management-components/files-and-articles",
    element: (
      <TaskManagementDevOnly>
        <FilesAndArticlesPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-management-components/viewer-components",
    element: (
      <TaskManagementDevOnly>
        <ViewerComponentsPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-management-components/cards",
    element: (
      <TaskManagementDevOnly>
        <CardsPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-management-components/modals",
    element: (
      <TaskManagementDevOnly>
        <ModalsPage />
      </TaskManagementDevOnly>
    ),
  },
  {
    path: "/task-management-components/other",
    element: (
      <TaskManagementDevOnly>
        <OtherPage />
      </TaskManagementDevOnly>
    ),
  },
];

type RouteFilter = (route: { path?: string }) => boolean;

/**
 * Assembles the route tree (MsalWrapper → MainLayout + fullscreen siblings).
 * With no filter the output is identical to the full standalone app. A filter
 * narrows both the MainLayout children and the fullscreen routes to a single
 * capability, which is how the app is mounted as a per-capability MFE.
 */
function buildRouteConfig(filter?: RouteFilter) {
  const layoutChildren = filter
    ? mainLayoutChildren.filter(filter)
    : mainLayoutChildren;
  const fullscreen = filter
    ? fullscreenRoutes.filter(filter)
    : fullscreenRoutes;

  const children: Array<Record<string, unknown>> = [];
  if (layoutChildren.length > 0) {
    children.push({ Component: MainLayout, children: layoutChildren });
  }
  children.push(...fullscreen);

  return [
    {
      Component: MsalWrapper,
      children,
    },
  ];
}

/** Shape of a fully-assembled route config (MsalWrapper root + children). */
export type AppRouteConfig = ReturnType<typeof buildRouteConfig>;

export const routeConfig = buildRouteConfig();

/**
 * Per-capability configuration. Each capability maps to the subset of routes it
 * owns plus the entry path the module root should land on.
 *
 * `filter` selects this capability's routes; `indexPath` is where "/" redirects
 * to when the Flexa shell mounts the module at its basename. Fixa's routes use
 * absolute paths (e.g. "/testbuy"), but a shell-mounted module's internal
 * routing starts at "/", which matches nothing on its own — so without this
 * redirect the module shows a blank page on mount/refresh.
 */
type CapabilityConfig = {
  filter: RouteFilter;
  indexPath: string;
};

const capabilities: Record<string, CapabilityConfig> = {
  testbuy: {
    filter: (route) =>
      route.path === "/testbuy" || route.path?.startsWith("/testbuy/") === true,
    indexPath: "/testbuy",
  },
  mediamaintenance: {
    filter: (route) =>
      route.path === "/mediamaintenance" ||
      route.path?.startsWith("/mediamaintenance/") === true,
    indexPath: "/mediamaintenance",
  },
};

type Capability = keyof typeof capabilities;

/** Builds a route config scoped to a single capability (keeps MainLayout chrome). */
export function getCapabilityRouteConfig(capability: Capability) {
  const { filter, indexPath } = capabilities[capability]!;
  const config = buildRouteConfig(filter);
  // Module-root redirect: the shell mounts us at its basename, so the initial
  // in-app path is "/". Send it to this capability's entry page.
  config[0]!.children.unshift({
    path: "/",
    element: <Navigate to={indexPath} replace />,
  });
  return config;
}

export const router = createBrowserRouter(routeConfig);
